import { useEffect, type ReactNode } from 'react';
import { ToastProvider, useToast } from '@/shared/context/ToastContext';
import { LoadingProvider, useGlobalLoading } from '@/shared/context/LoadingContext';
import { CurrencyProvider } from '@/shared/context/CurrencyContext';
import { registerToastHandler } from '@/utils/handleErrorApi';
import { registerLoadingHandler } from '@/utils/loadingBridge';

function ToastBridge({ children }: { children: ReactNode }) {
  const { showToast } = useToast();
  useEffect(() => {
    registerToastHandler(showToast);
  }, [showToast]);
  return <>{children}</>;
}

function LoadingBridge({ children }: { children: ReactNode }) {
  const { startLoading, stopLoading } = useGlobalLoading();
  useEffect(() => {
    registerLoadingHandler({ start: startLoading, stop: stopLoading });
  }, [startLoading, stopLoading]);
  return <>{children}</>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <LoadingProvider>
      <ToastProvider>
        <CurrencyProvider>
          <LoadingBridge>
            <ToastBridge>{children}</ToastBridge>
          </LoadingBridge>
        </CurrencyProvider>
      </ToastProvider>
    </LoadingProvider>
  );
}
